import { NotificationDefinition } from '../../types'
import { QuoteStuckInPreparingSignatureRequestStatusHeader } from './QuoteStuckInPreparingSignatureRequestStatusHeader'
import { QuoteStuckInPreparingSignatureRequestStatusListItem } from './QuoteStuckInPreparingSignatureRequestStatusListItem'
import { QuoteStuckInPreparingSignatureRequestStatusPreview } from './QuoteStuckInPreparingSignatureRequestStatusPreview'

export const quoteStuckInPreparingSignatureRequestStatusDefinition: NotificationDefinition =
  {
    listItemContent: QuoteStuckInPreparingSignatureRequestStatusListItem,
    previewHeaderContent: QuoteStuckInPreparingSignatureRequestStatusHeader,
    previewContent: QuoteStuckInPreparingSignatureRequestStatusPreview
  }
